<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<div class="root-nav" [class]="{'hide-root-nav': !(shouldShowNav$ | async) }">
  <div class="app-toolbar-container">
    <mat-toolbar class="mat-elevation-z2" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="left-nav" fxLayout="row" fxLayoutAlign="start center">
        @if ((menuBarImage$ | async); as menuBarImage) {
          <img id="menu-bar-image" class="menu-bar-image"
            fxHide.lt-md
            [src]="menuBarImage.src" [alt]="menuBarImage.altText" />
        }
        <nav mat-tab-nav-bar [tabPanel]="mainTabPanel">
          @if (pageEnabled$('dashboard') | async) {
            <a mat-tab-link
              routerLink="/dashboard"
              routerLinkActive #dashboardActive="routerLinkActive"
            [active]="dashboardActive.isActive">Dashboard</a>
          }
          @if (pageEnabled$('map') | async) {
            <a mat-tab-link
              routerLink="/map"
              routerLinkActive #mapActive="routerLinkActive"
            [active]="mapActive.isActive">Map</a>
          }
          @if (pageEnabled$('admin') | async) {
            <a mat-tab-link
              routerLink="/admin"
              routerLinkActive #adminActive="routerLinkActive"
            [active]="adminActive.isActive">Admin</a>
          }
        </nav>
      </div>
      <div class="right-nav" fxLayout="row" fxLayoutAlign="start center"
           fxLayoutGap="16px" fxLayoutGap.lt-md="8px" fxLayoutGap.lt-sm="0px">
        <dash-gis-theme-switcher class="icon-only"></dash-gis-theme-switcher>
        <dash-gis-user-tools class=""></dash-gis-user-tools>
      </div>
    </mat-toolbar>
  </div>
  <mat-tab-nav-panel #mainTabPanel class="dash-gis-main-content">
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
  <div style='display:none'>
    <table mat-table [dataSource]='dummyData'>
      <ng-container matColumnDef='a'>
        <th mat-header-cell *matHeaderCellDef>A</th>
        <td mat-cell *matCellDef='let element'>{{element.a}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef='["a"]'>A</tr>
      <tr mat-row *matRowDef='let row; columns: ["a"];'></tr>
    </table>
  </div>
</div>
